import React, { useState } from "react";
import Eye from "../../../../images/eye.svg";
import EyeSlash from "../../../../images/eye-slash.svg";
import XIcon from "../../../../images/XIcon.svg";
import CheckIcon from "../../../../images/CheckIcon.svg";
import PendingIcon from "../../../../images/PendingIcon.svg";
import "./KYCItem.scss";

function KYCItem({
  docType,
  status,
  onReadDocument,
  onAccept,
  onReject,
  onPending,
  isSelected,
  onSelect,
  isVisible,
}) {
  const [isEyeSlash, setIsEyeSlash] = useState(false);

  const getIcon = () => {
    switch (status) {
      case "Accepted":
        return <img src={CheckIcon} className="status-icon" alt="status" loading="lazy" />;
      case "Rejected":
        return <img src={XIcon} className="status-icon" alt="status" loading="lazy" />;
      case "Pending":
        return <img src={PendingIcon} className="status-icon" alt="status" loading="lazy" />;
      default:
        return null;
    }
  };

  const pendingButtonClass =
    status === "Pending" ? "status-button pending" : "status-button";
  const acceptedButtonClass =
    status === "Accepted" ? "status-button accepted" : "status-button";
  const rejectedButtonClass =
    status === "Rejected" ? "status-button rejected" : "status-button";
  const eyeBackground = isEyeSlash ? "eye-button.slash" : "eye-button";

  const toggleEyeIcon = () => {
    setIsEyeSlash(!isEyeSlash);
    onSelect();
    onReadDocument();
  };

  return (
    <div>
      <div className="kyc-item">
        <div className="kyc-input">
          <p className="classification">Classification</p>
          <div className="kyc-type">
            <p className="docType">{docType}</p>
          </div>
        </div>
        <button className={eyeBackground} onClick={toggleEyeIcon}>
          {isEyeSlash ? (
            <img src={EyeSlash} alt="View" className="eye-icon-slash" loading="lazy" />
          ) : (
            <img src={Eye} alt="View" className="eye-icon" loading="lazy" />
          )}
        </button>
        <button className={pendingButtonClass} onClick={onPending}>
          Pending
        </button>
        <button className={acceptedButtonClass} onClick={onAccept}>
          Accept
        </button>
        <button className={rejectedButtonClass} onClick={onReject}>
          Reject
        </button>
        <div className="status-container">
          <p className="status-text">Status:</p>
          <p className="status-result">{status}</p>
          {getIcon()}
        </div>
        {/* <input type="checkbox" className="kyc-checkbox" /> */}
      </div>
    </div>
  );
}

export default KYCItem;
